import * as React from 'react';
import { Props } from 'react';

import './MapMarker.scss';

const markerIcon = require('../../../assets/location_mark.svg');
const myMarkerIcon = require('../../../assets/location.svg');

export interface MapMarkerProps extends Props<MapMarker> {
    lat: number;
    lng: number;
    myGeo?: boolean;
}

export class MapMarker extends React.Component<MapMarkerProps, {
    opened: boolean;
}> {
    state = {
        opened: false
    };

    toggleMarker = () => {
        this.setState({
            opened: !this.state.opened
        });
    }

    render() {
        return (
            <div
                className='map-marker-container noselect'
                onClick={() => this.toggleMarker()}
            >
                <div className='map-marker-img'>
                    <img src={this.props.myGeo ? myMarkerIcon : markerIcon} />
                </div>
                {this.state.opened &&
                    <div className='baloon-wrapper'>
                        <div className='baloon'>
                            <div className='baloon-content hotel'>
                                {this.props.children}
                            </div>
                        </div>
                        <div className='baloon-wrapper__tail' />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/GoogleMap/MapMarker.tsx